import { render, staticRenderFns } from "./AdminLeadsByStatusCancelled.vue?vue&type=template&id=27ee9b85&scoped=true&"
import script from "./AdminLeadsByStatusCancelled.vue?vue&type=script&lang=js&"
export * from "./AdminLeadsByStatusCancelled.vue?vue&type=script&lang=js&"
import style0 from "./AdminLeadsByStatusCancelled.vue?vue&type=style&index=0&id=27ee9b85&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27ee9b85",
  null
  
)

export default component.exports